export default __webpack_public_path__ + "static/media/profile-no-image-tour.6b26d59f.svg";